import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
} from '@angular/core';
import { ButtonModule, ButtonSeverity } from 'primeng/button';
import { IconEnum } from 'shared/design-system/data-access/icon';
import {
    PaddingSize,
    PxSize,
    RemSize,
} from 'shared/design-system/data-access/layout';
import { ColorEnum } from 'shared/design-system/data-access/theme';

@Component({
    selector: 'it-button',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonModule],
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
    testId = input.required<string>();
    severity = input<ButtonSeverity>('primary');
    icon = input<IconEnum>();
    color = input<ColorEnum>();
    title = input<string>();
    label = input<string>();
    ariaLabel = input<string>();
    disabled = input<boolean>();
    loading = input<boolean>();
    text = input<boolean>();
    outlined = input<boolean>();
    fontSize = input<RemSize | PxSize>();
    padding = input<PaddingSize | PxSize>();
    fullWidth = input<boolean>();
    border = input<string>();
    backgroundColor = input<string>();
    width = input<string>();
    variant = input<'default' | 'icon-only' | 'square'>('default');
    hoverBackgroundColor = input<string>();

    clicked = output<Event>();
}
